export default __webpack_public_path__ + "static/media/camera.8fba6514.png";